import React, { useEffect, useState } from 'react';
import { useMonitoringVisitLog } from 'src/components/StartUp/studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { useAppSelector, useAppDispatch } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useIMVReportPage } from './UseIMVReportPage';
import VersionHistory from './VersionHistory';
import { DataTable } from '@pihealth/common-ui-library';
import staticData from '../../../resources/static.json';
import { setSelectedIMVReportData, setShowIMVReportCMPArr } from 'src/store/imvReport';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
const IMVReportTable: React.FunctionComponent<any> = () => {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const dispatch = useAppDispatch();
  const [loader, setLoader] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const [allImvReportRes, setAllImvReportRes] = useState([]);
  const [headerTitle, setHedertitle] = useState();
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState(null);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filterObject, setFilterObject] = useState<any>();

  const {
    allImvReportData,
    allImvReportDataIsError,
    allImvReportDataLoading,
    allImvReportDataIsSuccess,
    getAllImvReportData
  } = useIMVReportPage();
  const { getAllMonitoringVisits } = useMonitoringVisitLog();
  const getAllImvReportFunc = (from: number, size: number) => {
    getAllImvReportData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      data: filterObject,
      application: process.env.REACT_APP_NAME,
      from,
      size
    });
  };
  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string,
    from: number,
    size: number
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: currentApp,
      from,
      size,
      data: {}
    });
    const tempRows: any = [];
    allImvReportData.selected_data.map((listData: any) => {
      const data = Object.assign({}, listData);
      allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0
        ? allMonitoringResponse.data.selected_data.map((visit: any) => {
            if (visit.visit_type === 'Interim Monitoring Visit' && visit.id === listData.id) {
              tempRows.push({
                ...data,              
                start_date: visit.actual_start_date === null ? `${data.start_date}Z` : `${visit.actual_start_date}Z`,
                updated_on: data.updated_on ? `${data.updated_on}Z` : data.updated_on,
                actual_start_date: visit.actual_start_date,
                major_version: Number(data.major_version).toFixed(1).toString()
              });
            }
          })
        : tempRows.push({
            ...data,
            start_date: data.start_date,
            actual_start_date: null,
            major_version: Number(data.major_version).toFixed(1).toString()
          });
    });
    setAllImvReportRes(tempRows);
    setLoader(false);
  };
  const handle = (rowDetails: any) => {
    dispatch(setSelectedIMVReportData(rowDetails));
    dispatch(setShowIMVReportCMPArr('IMVReportPage'));
  };
  const handleVersionHistory = async (selectedRow: any) => {
    setHedertitle(selectedRow.visit_name);
    setDocId(selectedRow?.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      handle(data);
    },
    major_version: (data: any) => {
      handleVersionHistory(data);
    }
  };
  useEffect(() => {
    if (allImvReportDataLoading) {
      setLoader(true);
    }
    if (allImvReportDataIsError) {
      setAllImvReportRes([]);
      setRowsCount(0);
      setPageNumber(0);
      setLoader(false);
    }
    if (allImvReportDataIsSuccess) {
      setLoader(true);
      getMonitoringVisitList(
        studyId,
        selectedCountry,
        selectedSite,
        selectedAppSection,
        pageNumber * pageSize,
        pageSize
      );
    }
  }, [allImvReportDataIsError, allImvReportDataIsSuccess, allImvReportDataLoading]);
  useEffect(() => {
    if (!allImvReportDataLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllImvReportFunc(0, pageSize);
      } else {
        getAllImvReportFunc(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize, selectedCountry, studyId, selectedSite, filterObject]);
  useEffect(() => {
    if (allImvReportData) {
      setRowsCount(allImvReportData?.record_count);
      setAllImvReportRes(allImvReportData?.selected_data);
    }
  }, [allImvReportData]);
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${staticData.imvChecklist.file_export_name_report} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };
  return (
    <>
      <DataTable
        rows={allImvReportRes || []}
        columns={staticData.imvChecklist.columns}
        datePreference={userPreferedDateFormat}
        actions={actions}
        loading={loader}
        paging
        pageSize={pageSize}
        setPageSize={setPageSize}
        rowsCount={rowsCount}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        paginationMode="server"
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        dataTableProps={dataTableProps}
        filterValues={(data: any) => filterValues(data)}
        height="82vh"
      />
      {showVersionHistory && (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
        />
      )}
    </>
  );
};
export default IMVReportTable;
